<template>
  <v-select
    dense
    outlined
    item-value="value"
    item-text="name"
    v-if="isMobile"
    :label="fieldLabel"
    v-model="machine"
    :items="machines"
    prepend-inner-icon="mdi-crosshairs"
  ></v-select>
  <v-autocomplete
    dense
    v-else
    outlined
    item-value="value"
    item-text="name"
    :label="fieldLabel"
    v-model="machine"
    :items="machines"
    prepend-inner-icon="mdi-crosshairs"
  ></v-autocomplete>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  name: 'MachineSelection',
  computed: {
    ...mapGetters('webApp', ['filters']),
    ...mapGetters('downtimeLog', ['machineList', 'machineFilterField']),
    fieldName() {
      return this.machineFilterField;
    },
    fieldLabel() {
      return this.fieldName === 'linename' ? 'Line' : this.$t('downtime.machine');
    },
    allLabel() {
      return this.fieldName === 'linename'
        ? 'All Lines'
        : this.$t('downtime.allMachines');
    },
    isMachineFilterInactive() {
      return !Object
        .keys(this.filters)
        .includes(this.fieldName);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    machines() {
      let machines = [];
      if (this.machineList && this.machineList.length) {
        machines = [{
          name: this.allLabel,
          value: 'All',
        }, ...this.machineList];
      }
      return machines;
    },
    machine: {
      get() {
        const machineFilter = this.filters && this.filters[this.fieldName];
        if (machineFilter) {
          return machineFilter.value;
        }
        return this.machines && this.machines.length && this.machines[0].value;
      },
      set(machineVal) {
        this.setMachineFilter(machineVal);
      },
    },
  },
  created() {
    if (this.machines && this.machines.length) {
      this.clearOppositeFilter();
      if (this.isMachineFilterInactive) {
        this.setMachineFilter(this.machines[0].value);
      }
    } else {
      this.fetchMachines();
    }
  },
  methods: {
    ...mapMutations('webApp', ['setFilter', 'removeFilter']),
    ...mapActions('downtimeLog', ['fetchMachines']),
    clearOppositeFilter() {
      const oppositeField = this.fieldName === 'linename' ? 'machinename' : 'linename';
      if (this.filters && this.filters[oppositeField]) {
        this.removeFilter(oppositeField);
      }
    },
    setMachineFilter(val) {
      this.clearOppositeFilter();
      this.setFilter({
        field: this.fieldName,
        value: {
          value: val,
          operation: 'eq',
        },
      });
    },
  },
  watch: {
    machines(val) {
      if (val && val.length) {
        this.clearOppositeFilter();
        if (this.isMachineFilterInactive) {
          this.setMachineFilter(val[0].value);
        }
      }
    },
  },
};
</script>
